import { jsx as _jsx } from "react/jsx-runtime";
// Importing hooks
import { useShallow } from 'zustand/react/shallow';
// Importing store
import { usePostStore } from '../../../store/post.store';
// Importing 3rd party components
import Box from '@mui/material/Box';
// ----------------------------------------------------------------------
export const PlayerLayout = (props) => {
    // Destructuring props
    const { children } = props;
    // Adding post store
    const { post } = usePostStore(useShallow((state) => ({
        post: state.post,
    })));
    return (_jsx(Box, { sx: Object.assign(Object.assign({ backgroundColor: 'primary.main' }, ((post === null || post === void 0 ? void 0 : post.thumbnail) && {
            backgroundImage: `url(${post.thumbnail})`,
        })), { backgroundPosition: 'center', backgroundSize: 'cover', boxShadow: 'inset 0px -30px 50px -15px rgba(0, 0, 0, 0.5)' }), children: _jsx(Box, { sx: {
                backdropFilter: 'blur(50px)',
                height: '100%',
                width: '100%',
            }, children: children }) }));
};
